import { useTranslator } from '@bluebeam/react-i18n';
import BasicButtonGroup from 'components/inputs/BasicButtonGroup';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const ViewTypeToggle: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const { translate } = useTranslator(['roverNavigation']);

  const { state: appState } = useContext(AppStoreContext);
  const { selectedProject } = appState;

  const navigateToView = (path: string): void => {
    const fileViewPathname = `/project/${selectedProject}/${path}`;
    if (location.pathname !== fileViewPathname) {
      history.push(fileViewPathname);
    }
  };

  const handleToggleSelectedView = (view: string[]): void => {
    if (view[0] === TabTypes.map.name) {
      navigateToView(TabTypes.map.path);
    } else if (view[0] === TabTypes.file.name) {
      navigateToView(TabTypes.file.path);
    }
  };

  const TabTypes = {
    map: { name: translate('roverNavigation:mapView'), path: 'map' },
    file: { name: translate('roverNavigation:fileView'), path: 'dashboard' },
  };

  const appViewMode =
    location.pathname === `/project/${selectedProject}/map`
      ? TabTypes.map.name
      : TabTypes.file.name;

  return (
    <BasicButtonGroup
      id="traditional-map-view-button-toggle"
      disabled={false}
      options={[TabTypes.file.name, TabTypes.map.name]}
      onOptionClick={handleToggleSelectedView}
      selected={[appViewMode]}
    />
  );
};

export default ViewTypeToggle;
